import React, { useEffect, useRef } from "react"
import {
  Banner,
  Background,
  BannerTitle,
  HeadLine,
  Canvas,
} from "./home-banner-styles"
import useWindowSize from "../../hooks/useWindowSize"
import { useGlobalContext } from "../../context/Context"

const HomeBanner = ({ onCursor }) => {
  const canvas = useRef(null)
  const size = useWindowSize()
  const { currentTheme } = useGlobalContext()

  useEffect(() => {
    const renderingElement = canvas.current
    const drawElement = renderingElement.cloneNode()
    const drawingCtx = drawElement.getContext("2d")
    const renderingCtx = renderingElement.getContext("2d")

    renderingCtx.globalCompositeOperation = "source-over"
    renderingCtx.fillStyle = currentTheme === "dark" ? "#000000" : "#ffffff"
    renderingCtx.fillRect(0, 0, size.width, size.height)

    let lastX
    let lastY

    let moving = false

    renderingElement.addEventListener("mouseover", e => {
      moving = true
      lastX = e.pageX - renderingElement.offsetLeft
      lastY = e.pageY - renderingElement.offsetTop
    })

    renderingElement.addEventListener("mouseup", e => {
      moving = false
      lastX = e.pageX - renderingElement.offsetLeft
      lastY = e.pageY - renderingElement.offsetTop
    })

    renderingElement.addEventListener("mousemove", e => {
      if (moving) {
        drawingCtx.globalCompositeOperation = "source-over"
        renderingCtx.globalCompositeOperation = "destination-out"
        let currentX = e.pageX - renderingElement.offsetLeft
        let currentY = e.pageY - renderingElement.offsetTop

        drawingCtx.lineJoin = "round"
        drawingCtx.moveTo(lastX, lastY)
        drawingCtx.lineTo(currentX, currentY)
        drawingCtx.closePath()
        drawingCtx.lineWidth = 120
        drawingCtx.stroke()
        lastX = currentX
        lastY = currentY
        renderingCtx.drawImage(drawElement, 0, 0)
      }
    })
  }, [currentTheme, size.width, size.height])

  const parent = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        staggerChildren: 0.2,
      },
    },
  }

  const child = {
    initial: { y: 800 },
    animate: {
      y: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  }
  return (
    <Banner>
      <Background>
        <video
          muted
          height="100%"
          width="100%"
          loop
          autoPlay
          src={require("../../assets/video/video.mp4")}
        />
      </Background>
      <Canvas
        ref={canvas}
        height={size.height}
        width={size.width}
        onMouseLeave={onCursor}
        onMouseEnter={() => onCursor("hovered")}
      />
      <BannerTitle variants={parent} initial="initial" animate="animate">
        <HeadLine variants={child}>DIG</HeadLine>
        <HeadLine variants={child}>DEEP</HeadLine>
      </BannerTitle>
    </Banner>
  )
}

export default HomeBanner
